import script from "./ResumeQualifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeQualifications.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeQualifications.vue?vue&type=style&index=0&id=7e9e200e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9e200e"]])

export default __exports__